import React, { useState, useEffect } from 'react';
import { Form, Select } from "antd";
import { errorCatch, READWITH, QueryParam, JSXMap, READ, GET, getObjectDisplay, makeAnswer, getAnswersFromContext, getObjectAnswerFromContext, QueryOrder, funcClient, JSX, QueryDetail, getAnswerValue } from '../../components/Tool'
import { useServiceContext, useUserContext } from '../../components/Context';
import "./index.less"
import { useSelector } from 'react-redux';
import Field from '../../components/Field';
var _ = require('lodash');
const { Option } = Select;

function AnswerParameter({ auth, context, question, parameter, value, onChange }) {
    const meta = useSelector(state => state.meta);
    const changeAnswer = (value, element, parameter, objectName) => {
        if (value !== undefined && value !== null && element) {
            let a = makeAnswer(context, question, value, element.label || element, parameter, objectName);
            onChange(a);
        }
    };
    if (parameter && parameter.answerType && parameter.groupID > 0) {
        let v = getAnswerValue(value);
        console.log(v); // answerBool !!!
        return (
            <Field
                auth={auth}
                item={{
                    // source: ""
                    label: parameter.title,
                    name: `answer-${parameter.ID}`,
                    // filterType: "group", // range
                    type: parameter.answerType.name, /**FIX: answerType.name может иметь тип select или multiselect которых нет в Field, если они пока не используются в системе то нужно подумать можно ли от них избавиться*/
                    source: `/api/query/${parameter.objectName}`,
                    queryFilter: (parameter.objectName === "Answers") ? [
                        QueryDetail("model"),
                        QueryOrder("ID", "ASC"),
                    ] : [
                        QueryParam("w-question.ID", question.ID),
                        QueryOrder("sorting", "ASC")
                    ]
                }}
                // value={_.get(value, "[0].value")}
                value={v}
                onChange={(v) => changeAnswer(v, getObjectDisplay(v, parameter.objectName, meta), parameter, (parameter.groupID > 0) ? parameter.objectName : "levels")}
                mode="model" />)
    } else {
        return (
            <Select
                size="large"
                showSearch
                // value={_.get(value, "[0].value")}
                style={{ minWidth: 400 }}
                optionLabelProp="label"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(v, e) => changeAnswer(v, e, parameter, "levels")}
            >
                {JSXMap(parameter.levelsParameter, (answer, idx) => <Option key={idx} className="question-answer" value={answer.ID} label={answer.name}>
                    {answer.name}
                </Option>)}
            </Select>
        )
    }
}
function AnswerSelect({ auth, context, question, value, onChange }) {
    const meta = useSelector(state => state.meta);
    const [answers, setAnswers] = useState([]);
    useEffect(() => {
        if (question && question.objectName) {
            if ((question.answerType.name === "select") || (question.answerType.name === "multiselect")) {
                if (question.objectName === "Answers") {
                    READWITH(auth, question.objectName, [
                        QueryParam("w-question.ID", question.ID),
                        QueryOrder("sorting", "ASC")
                    ], ({ data }) => {
                        setAnswers(data);
                    },
                        errorCatch
                    );
                } else {
                    READ(auth, question.objectName,
                        ({ data }) => {
                            setAnswers(data);
                        },
                        errorCatch
                    );
                }
            }
        }
    }, [auth, question]);
    const changeAnswer = (value, element, parameter, objectName) => {
        if (value && element) {
            let a = makeAnswer(context, question, value, element.label, parameter, objectName);
            onChange(a);
        }
    };
    return (
        <Select
            size="large"
            showSearch
            value={_.get(value, "[0].value")}
            style={{ minWidth: 300 }}
            optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={(v, e) => changeAnswer(v, e)}
        >
            {JSXMap(answers, (answer, idx) => <Option key={idx} className="question-answer" value={answer.ID} label={getObjectDisplay(answer, question.objectName, meta)}>
                {getObjectDisplay(answer, question.objectName, meta)}
            </Option>)}
        </Select>
    )
}

export default function Question(props) {
    const user = useUserContext();
    const service = useServiceContext();
    const { auth, form, context, fun, onQuestionChange } = props;

    const meta = useSelector(state => state.meta);
    const [answers, setAnswers] = useState();
    const [answerType, setAnswerType] = useState();
    const [question, setQuestion] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.resetFields();
    }, [context, fun]);
    useEffect(() => {
        if (context && question && question.objectName) {
            if (question.answerType.name === "object") {
                GET(auth, `/api/parameters/${question.objectName}/${context.ID}${(question.groupID > 0) ? "/" + question.groupID : ""}`,
                    ({ data }) => {
                        setAnswers(data);
                    },
                    errorCatch
                );
            }
        }
    }, [context, question]);
    useEffect(() => {
        setQuestion(_.get(fun, "fsmFunction.question"));
    }, [fun]);
    useEffect(() => {
        setAnswerType(_.get(question, "answerType.name"));
    }, [question]);

    const changeObjectAnswer = (value, element, parameter, objectName, answer) => {
        if (service && value && element) {
            let a = makeAnswer(context, question, value, element.label, parameter, objectName);
            funcClient(auth, context, service.ID, fun.ID, question, [a], onQuestionChange, {
                lock: () => setLoading(true),
                unlock: () => setLoading(false),
            });
        }
    };

    const initialValuesFromContext = () => {
        if (answers) {
            if ((answerType !== "void") && (answerType !== "object")) {
                const answer = getAnswersFromContext(context, question);
                return { "answer-0": answer }
            }
            if (answerType === "object") {
                return _.fromPairs(answers.map((parameter, idx) => {
                    const answer = getObjectAnswerFromContext(context, question, parameter);
                    return [
                        "answer-" + parameter.ID, answer
                    ]
                }))
            }
        }
    }
    return (<div className='question'>
        {question && <Form
            form={form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={initialValuesFromContext()}
        >
            {((answerType !== "void") && (answerType !== "object")) && <>
                {JSX(() => {
                    return (
                        <Form.Item label={<span className="question-title">{question.title}</span>}
                            name="answer-0"
                            rules={[{ required: true, message: 'Пожалуйста, укажите значение!' }]}
                        >
                            <AnswerSelect auth={auth} context={context} question={question} />
                        </Form.Item>
                    )
                })}
            </>}
            {(answerType === "object") && <>
                <div className="question-group-title">{question.title}</div>
                {JSXMap(answers, (parameter, idx) => {
                    return (
                        <Form.Item
                            key={idx}
                            label={(parameter.levelsParameter || (parameter.answerType && parameter.answerType.name !== "bool" && parameter.answerType.name !== "boolean")) ? <span className="question-title">{parameter.name || parameter.title}</span> : undefined}
                            name={`answer-${parameter.ID}`}
                            rules={[{ required: true, message: 'Пожалуйста, укажите значение!' }]}
                        >
                            <AnswerParameter auth={auth} context={context} question={question} parameter={parameter} />
                        </Form.Item>
                    );
                })}
            </>}

        </Form>}
    </div>);
}